"use client";

import { Search } from "@/components/Search";

type SearchResult = {
  title: string;
  excerpt: string;
  url: string;
  category?: string;
};

type DocsSearchProps = {
  searchData: SearchResult[];
};

export function DocsSearch({ searchData }: DocsSearchProps) {
  return <Search items={searchData} placeholder="Search documentation..." />;
}
